import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  EmmaButton,
} from '@axa-asia/emma-stylesheet';
import React, { FC } from 'react';
import AddressAbbreviationList from '../AddressAbbreviationList';
import { useSelector } from 'react-redux';
import { getAddressAbbreviationLabel } from '../../../selectors/changeAddressSelector';
import { resolveLocalizedText } from '../../../../../utils';

type AddressAbbreviationListDialogProps = {
  isShow: boolean;
  onClose: () => void;
};

const AddressAbbreviationListDialog: FC<AddressAbbreviationListDialogProps> = ({
  isShow,
  onClose,
}) => {
  const { title, gotIt } = useSelector(getAddressAbbreviationLabel);

  return (
    <Dialog show={isShow} onHide={onClose}>
      <DialogHeader>{resolveLocalizedText(title)}</DialogHeader>
      <DialogBody>
        <AddressAbbreviationList />
      </DialogBody>
      <DialogFooter>
        <EmmaButton outline onClick={onClose}>
          {resolveLocalizedText(gotIt)}
        </EmmaButton>
      </DialogFooter>
    </Dialog>
  );
};

export default AddressAbbreviationListDialog;
